import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "CP3K";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

// master data
export const masterRegion = "Master/List/region/";
export const masterEducation = "Master/List/education/";
export const masterRank = "Master/List/rank/";
export const masterRankPppk = "Master/List/rankPppk/";
export const masterPosition = "Master/List/position/";
export const masterPositionPppk = "Master/List/positionPppk/";
export const masterWorkUnit = "Master/List/workUnit/";
export const masterMaritalStatus = "Master/List/maritalStatus/";
export const masterBank = "Master/List/bank/";
export const masterReligion = "Master/List/religion/";

export const cp3kPeriodCreate = "Kepegawaian/CP3K/createPeriod/";
export const cp3kPeriodList = "Kepegawaian/CP3K/listPeriod/";
export const cp3kPeriodDetail = "Kepegawaian/CP3K/detailPeriod/";
export const cp3kPeriodInactive = "Kepegawaian/CP3K/deletePeriode/";
export const cp3kPeriodActive = "Kepegawaian/CP3K/activePeriod/";

export const cp3kGetProjection = "Kepegawaian/CP3K/getProjectionCPNS/";
export const cp3kList = "Kepegawaian/CP3K/listCandidate/";
export const cp3kDelete = "Kepegawaian/CP3K/delete/";
export const cp3kActive = "Kepegawaian/CP3K/active/";
export const cp3kExportUsulan = "Kepegawaian/CP3K/exportExcelUsulan/";
export const cp3kExportLampiran = "Kepegawaian/CP3K/exportExcelLampiran/";
export const cp3kCreate = "Kepegawaian/CP3K/create/";
export const cp3kDetail = "Kepegawaian/CP3K/detail/";
export const cp3kUploadSK = "Kepegawaian/CP3K/uploadSK/";
export const cp3kCreateDecreeCollective =
  "Kepegawaian/CP3K/createDecreeCollective/";
export const cp3kDetailDecreeCollective =
  "Kepegawaian/CP3K/detailDecreeCollective/";

export const cp3kDownloadSKCollective =
  "Kepegawaian/CP3K/downloadSKCollective/";
export const cp3kDownloadDraftSK = "Kepegawaian/CP3K/downloadDraftSK/";
export const cp3kImportExcel = "Kepegawaian/CP3K/importExcel/";

export const masterSignatoryOfficial = "Kepegawaian/SignatoryOfficial/list/";
export const cp3kDownloadSPMT = "Kepegawaian/CP3K/downloadSPMT/";
export const cp3kDownloadPlanLetter = "Kepegawaian/CP3K/downloadDraftPlanLetter/";

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
